// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-business-modal-modal_card-tmov4 {
  width: 340px;
  height: auto;
  max-height: 600px;
}

.add-business-modal-textField_container-KHktS {
  width: 100%;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/add-business-modal/add-business-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".modal_card {\n  width: 340px;\n  height: auto;\n  max-height: 600px;\n}\n\n.textField_container {\n  width: 100%;\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `add-business-modal-modal_card-tmov4`,
	"textField_container": `add-business-modal-textField_container-KHktS`
};
export default ___CSS_LOADER_EXPORT___;
